import { IBackgroundJobExtendedInfo } from '../types/IBackgroundJobExtendedInfo';
import { IGetItemsResult } from '../types/IGetItemsResult';
import { Request } from './Request';

export interface IGetBackgroundJobExtendedInfoParams {
  backgroundJobId: string;
}

export interface IGetBackgroundJobExtendedInfoResult extends IGetItemsResult, IBackgroundJobExtendedInfo {}

export class GetBackgroundJobExtendedInfoRequest extends Request<IGetBackgroundJobExtendedInfoParams, IGetBackgroundJobExtendedInfoResult> {
  constructor(params: IGetBackgroundJobExtendedInfoParams) {
    super('getBackgroundJobExtendedInfo', params);
  }
}
